import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import IAsyncModel from "models/IAsyncModel";
import { IClient } from "models/PaymentModel";
import {
  EmptyTaxSystem,
  TaxSystem,
} from "adminPanel/settings/settingTaxes/ITaxSystem";
import {
  EmptyNumbersCard,
  INumbersCard,
} from "adminPanel/settings/numbers/INumbersCard";
import settingsAPI from "adminPanel/settings/settingsAPI";
import { ICurrency } from "adminPanel/pos/models/IPosProperties";

export interface TaxState {
  system: TaxSystem;
  subscriptionDate: Date;
  defaultClient?: IClient;
  isPriceIncludeTax: boolean;
}
export interface OrganizationsSettingsState extends IAsyncModel {
  taxState: TaxState;
  numbersState: INumbersCard;
  currencies: ICurrency[];
  allowedCountries: string[];
  allowedCurrencies: string[];
  //cont. here rest of organizations settings later on instead of calling the settings api many times
}

const initialTaxState: TaxState = {
  system: TaxSystem.NotSelected,
  subscriptionDate: new Date(),
  isPriceIncludeTax: false,
};

const iniTialOrganizationsSettingsState: OrganizationsSettingsState = {
  taxState: initialTaxState,
  numbersState: EmptyNumbersCard,
  currencies: [],
  allowedCountries: [],
  allowedCurrencies: [],
};

export const OrganizationsSettingsAsync = createAsyncThunk(
  "settings/getOrganizationsSettings",
  async (_, { dispatch }) => {
    var organizationSettings: OrganizationsSettingsState = {
      ...iniTialOrganizationsSettingsState,
    };
    const resp = await settingsAPI.GetOrganizationsSettings();
    if (resp.data.taxState) {
      organizationSettings.taxState = {
        subscriptionDate: resp.data.taxState.subscriptionDate,
        system: resp.data.taxState.system,
        defaultClient: resp.data.taxState.defaultClient,
        isPriceIncludeTax: resp.data.taxState.isPriceIncludeTax ?? false,
      } as TaxState;
    }

    if (resp.data.numbersState) {
      organizationSettings.numbersState = resp.data.numbersState;
    }

    if (resp.data.currencies) {
      organizationSettings.currencies = resp.data.currencies;
    }

    if (resp.data.allowedCountries) {
      organizationSettings.allowedCountries = resp.data.allowedCountries;
    }

    if (resp.data.allowedCurrencies) {
      organizationSettings.allowedCurrencies = resp.data.allowedCurrencies;
    }

    return organizationSettings;
  },
);

export const organizationSettingSlice = createSlice({
  name: "settings",
  initialState: iniTialOrganizationsSettingsState,
  reducers: {
    initialize: (state) => {
      return state;
    },
    setNumbersState: (state, action: PayloadAction<INumbersCard>) => {
      state.numbersState = action.payload;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(OrganizationsSettingsAsync.fulfilled, (_, action) => {
        return action.payload;
      })
      .addCase(OrganizationsSettingsAsync.rejected, () => {
        return iniTialOrganizationsSettingsState;
      });
  },
});

export const { setNumbersState } = organizationSettingSlice.actions;

export default organizationSettingSlice.reducer;
